module.exports = __webpack_public_path__ + "static/img/end01.28098bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/end01.jpg
// module id = 1432
// module chunks = 0